import { SimpleFormComponentProps, SimpleFormMethods } from 'app/infrastructure/simple-form/types';
import { Checkbox } from 'ui';
import * as React from 'react';

export const checkboxCreator = (props: SimpleFormComponentProps, fieldMethods: SimpleFormMethods) => {
 
  return (
    <Checkbox
      className={props.className}
      componentId={props.name}
      value={fieldMethods.getProperty(props.name)}
      label={fieldMethods.buildLabel(props.label)}
      onChange={fieldMethods.handleChange(props.name)}
      validation={fieldMethods.getValidation(props.name)}
      info={{visible: !!props.infoText, text: props.infoText}}
    />);
};
